import { clsx } from "clsx"

const CenteredHero = ({ children, title, paragraph, custCls, custTitleCls = "", writer = "", noTitle = false, custTitleFont = "", custParagraphFont = "", dynamicBg = "" }) => {
  return (
    <>
      <section className={clsx("max-sm:px-2 pt-16 pb-20 text-center w-full bg-cover bg-center no-repeat flex items-center", custCls)} style={dynamicBg ? { backgroundImage: `url(${dynamicBg})` } : {}}>
        <div className="w-full">
          <h1 className={clsx("text-white font-light inline-block", { "mb-5": paragraph && !custTitleFont, "text-5xl md:text-6xl lg:text-7xl": !noTitle, "tracking-wide": noTitle, "font-agcasmlt": !noTitle && !custTitleCls }, custTitleCls, custTitleFont)}>{title}</h1>
          {paragraph &&
            <p className={clsx("text-sm md:text-base lg:text-lg text-white text-center sm:w-3/5 lg:w-[44%] mx-auto", { "font-light": !custParagraphFont }, custParagraphFont)}>{writer ? `"${paragraph}"` : paragraph}</p>
          }
          {writer && (
            <span className="text-sm md:text-base lg:text-lg font-americanTC font-light tracking-wide text-white text-center w-[44%] mx-auto">{writer}</span>
          )}
        </div>
        {children}
      </section>
    </>
  )
}

export default CenteredHero